import { AbstractControl } from '@angular/forms';
import { FormGeneratorComponent, ISearchResponse2, OptionLabelType } from 'ets-fe-ng-sdk';
import { IFormSchema as IFS } from 'ets-fe-ng-sdk';
import { Observable } from 'rxjs';

export interface ISR<T> extends ISearchResponse2<T> {
  pageable: Pageable;
}

interface Pageable {
  offset: number;
  sort: Sort;
  pageNumber: number;
  pageSize: number;
  paged: boolean;
  unpaged: boolean;
}

interface Sort {
  empty: boolean;
  sorted: boolean;
  unsorted: boolean;
}

export interface IFormSchema<
  TFormGroup extends {
    [K in keyof TFormGroup]: AbstractControl<any, any>;
  } = any,
> extends IFS<TFormGroup> {
  onChangeFunc?: (
    row: { [K in keyof TFormGroup]?: TFormGroup[K]['value'] },
    cellValue?: any,
    component?: FormGeneratorComponent<TFormGroup>,
  ) => Observable<any[]> | any;
  labelType?: OptionLabelType;
  field: keyof TFormGroup;
}

export enum EDashboardView {
  naicom = 'N',
  insurer = 'I',
  cifm = 'CIFM',
}

export enum ESystem {
  admin = 'admin',
  crm = 'crm',
  partner = 'partner',
  candidate = 'candidate',
}
